import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';
import _ from "lodash";

import HeaderContainer from "../Header/HeaderContainer";
import Spinner from "COMPONENTS/Spinner/Spinner";
import SettingsPage from "./SettingsPage";
// Constants
import { ERROR } from "UTILS/Constants";
// selectors
import { selectUserName, selectCustomerId } from "../../MainLayout/selectors";
import { selectUserRole } from "../../Whiteboard/selectors";
import { 
  getModules, getHeaderIcons, selectAllowedDownloads, selectSubModulesScreenshare,
  selectSubModulesAudioVideo,
  getIsOrganizer, getSubLoggingLevels, getLoggingLevel, getSSODetails, 
  getStorageDetails, getRecordingStorageDetails,
  isDownloadModuleSelected, getIsSSOEnabled, getIsSystemPassword, 
  getURIIdentifier, getIsPasscodeEnabled, getBandwidthSettings, 
  isVideoOrSnapshotSelected, isScreenShareSelected, isVideoSelected,
  getConcurrentSessionData, getScreenMaskSetting,
} from "../../CommonComponents/Header/selectors";
import {
  getUserNotifySetting, getUserInventMsgCustomize, getIsEntryAllowed, getIconLarge,
  getIsReductionLogs, getHorizontalDisplayFixed, getDisableCanvasEdit, getDisableIcsFile,
  getEnableVideoBlur,
} from "REDUX/Selector/OrganisationSelector";

//Utilities

// Strings
import { getMessage } from "CONFIG/i18n";

//Actions
import { organisationAction } from "CONFIG/ActionFactory";

class SettingsPageContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      spinnerVisibility: false,
    };
  }

  componentDidMount () {
    this.getCustomerInfo();
  }
  getCustomerInfo = () => {
    this.setState({spinnerVisibility: true});
    organisationAction.getCustomersAction(this.props.customerId).then(
      responseObject => {  
        this.setState({spinnerVisibility:false});
      }, error => {
        console.error("Error getting customer info", error);
        this.setState({spinnerVisibility: false});
      });
  };

  renderSpinner = () => {
    return <Spinner showSpinner={this.state.spinnerVisibility} />;
  }

  handleCancelClick = () => {
    this.props.history.goBack();
  };

  verifyStorage=(storageElement,callback)=>{
    this.setState({spinnerVisibility: true })
    organisationAction.verifyStorage(storageElement).then(
      data => {
        this.setState({spinnerVisibility: false })
        callback && callback();
      }
    ).catch (
      error => {
        this.setState({spinnerVisibility: false })
        callback && callback(error);
      }
    )
  }

  updateCustomerSettings = (details, callback)=>{
    this.setState({spinnerVisibility: true });
    organisationAction.updateCustomerSettings(this.props.customerId, details).then(
      data => { organisationAction.getCustomersAction(this.props.customerId).then(
        responseObject => {
          callback && callback();
          toastr.success(getMessage("SETTINGS_SAVED"));
          this.setState({spinnerVisibility:false},()=>{ 
            setTimeout(()=>{this.props.history.goBack()
            },1000)}); 
        });
      }
    ).catch (
      error => {
        this.setState({spinnerVisibility:false})
        if(error.code !== ERROR.NOT_AUTHORIZED)
          toastr.error(getMessage(error.code));
        callback && callback(error);
      }
    )
  }

  render() {
    return (
      <>
        {this.renderSpinner()}
        <HeaderContainer
          title={getMessage("SETTINGS")}
          headerButtonText={getMessage("ADD_USER")}
          showModal={false}
          history={this.props.history}
          showAboutOrgModal={false}
          getAllUserData={()=>{}}
          logoUrl={this.props.logoUrl}
          showQRPopUp={false}
          isAdmin={true}
          showQR={false}
          isDashboard={false}
        />
        <SettingsPage
          verifyStorage={this.verifyStorage}
          updateCustomerSettings={this.updateCustomerSettings}
          handleCancelClick={this.handleCancelClick} 
          userName={this.props.userName}
          role={this.props.role}
          customerId={this.props.customerId}
          modules={this.props.modules}
          allowedDownloads={this.props.allowedDownloads}
          subModulesScreenshare={this.props.subModulesScreenshare}
          subModulesAudioVideo={this.props.subModulesAudioVideo}
          isOrganizer={this.props.isOrganizer}
          availableSubLoggingLevels={this.props.availableSubLoggingLevels}
          loggingLevel={this.props.loggingLevel}
          storageDetails={this.props.storageDetails}
          recordingStorageDetails={this.props.recordingStorageDetails}
          SSODetails={this.props.SSODetails}
          bandwidthSettings={this.props.bandwidthSettings}
          isDownloadModuleSelected={this.props.isDownloadModuleSelected}
          isVideoSelected={this.props.isVideoSelected}
          isVideoOrSnapshotSelected={this.props.isVideoOrSnapshotSelected}
          isScreenShareSelected={this.props.isScreenShareSelected}
          headerIcons={this.props.headerIcons}
          isSSOEnabled={this.props.isSSOEnabled}
          uriIdentifier={this.props.uriIdentifier}
          isPasscodeEnabled={this.props.isPasscodeEnabled}
          isSystemPassword={this.props.isSystemPassword}
          logoUrl={this.props.logoUrl}
          concurrentSessionData={this.props.concurrentSessionData}
          cobrowseSettings={this.props.cobrowseSettings}
          availableModules={this.props.availableModules}
          recordingMethod={this.props.recordingMethod}
          recordingTarget={this.props.recordingTarget}
          audioRecordingMessage={this.props.audioRecordingMessage}
          videoRecordingMessage={this.props.videoRecordingMessage}
          retentionPeriod={this.props.retentionPeriod}
          userNotifySetting={this.props.userNotifySetting}
          userInventMsgCustomize={this.props.userInventMsgCustomize}
          screenMaskSetting={this.props.screenMaskSetting}
          isEntryAllowedSettings={this.props.isEntryAllowedSettings}
          iconLargeSettings={this.props.iconLargeSettings}
          isReductionLogs={this.props.isReductionLogs}
          horizontalDisplayFixedSettings={this.props.horizontalDisplayFixedSettings}
          disableCanvasEdit={this.props.disableCanvasEdit}
          disableIcsFile={this.props.disableIcsFile}
          operatorSkills={this.props.operatorSkills}
          enableVideoBlur={this.props.enableVideoBlur}
        />
       </>
    )
  }
}

const mapStateToProps = state => {
  return {
    userName: selectUserName(state),
    role: selectUserRole(state),
    customerId: selectCustomerId(state),
    modules: getModules(state),
    allowedDownloads: selectAllowedDownloads(state),
    subModulesScreenshare: selectSubModulesScreenshare(state),
    subModulesAudioVideo: selectSubModulesAudioVideo(state),
    isOrganizer: getIsOrganizer(state),
    availableSubLoggingLevels: getSubLoggingLevels(state),
    loggingLevel: getLoggingLevel(state),
    storageDetails: getStorageDetails(state),
    recordingStorageDetails: getRecordingStorageDetails(state),
    SSODetails:getSSODetails(state),
    isDownloadModuleSelected: isDownloadModuleSelected(state),
    isScreenShareSelected: isScreenShareSelected(state),
    isVideoSelected: isVideoSelected(state),
    isVideoOrSnapshotSelected: isVideoOrSnapshotSelected(state),
    headerIcons: getHeaderIcons(state),
    isSSOEnabled: getIsSSOEnabled(state),
    uriIdentifier: getURIIdentifier(state),
    isPasscodeEnabled: getIsPasscodeEnabled(state),
    isSystemPassword: getIsSystemPassword(state),
    bandwidthSettings: getBandwidthSettings(state),
    logoUrl: state.OrganisationReducer.logoUrl,
    concurrentSessionData: getConcurrentSessionData(state),
    cobrowseSettings: state.OrganisationReducer.cobrowseSettings,
    availableModules: state.OrganisationReducer.customerData.modules,
    recordingMethod: state.OrganisationReducer.customerData.recordingMethod,
    recordingTarget: state.OrganisationReducer.customerData.recordingTarget,
    audioRecordingMessage: state.OrganisationReducer.customerData.audioRecordingMessage,
    videoRecordingMessage: state.OrganisationReducer.customerData.videoRecordingMessage,
    retentionPeriod: state.OrganisationReducer.customerData.retentionPeriod,
    userNotifySetting: getUserNotifySetting(state),
    userInventMsgCustomize: getUserInventMsgCustomize(state),
    screenMaskSetting: getScreenMaskSetting(state),
    isEntryAllowedSettings: getIsEntryAllowed(state),
    iconLargeSettings: getIconLarge(state),
    isReductionLogs: getIsReductionLogs(state),
    horizontalDisplayFixedSettings: getHorizontalDisplayFixed(state),
    disableCanvasEdit: getDisableCanvasEdit(state),
    disableIcsFile: getDisableIcsFile(state),
    operatorSkills: state.OrganisationReducer.operatorSkills,
    enableVideoBlur: getEnableVideoBlur(state),
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(SettingsPageContainer));
